import doctorModalContentUrl from './modals/doctor/doctor.ngtemplate.html';
import patientModalContentUrl from './modals/patient/patient.ngtemplate.html';
import modalTemplateUrl from './modals/wrapper.ngtemplate.html';
import filters from './modals/filters/file-size';
import patientFileTransfer from './modals/patient/patient-file-transfer';
import doctorFileTransfer from './modals/doctor/doctor-file-transfer';

import stampit from 'stampit';
import _ from 'lodash';

const componentName = 'fileTransfer';
const serviceName = 'FileTransferRealtimeComponent';
const moduleName = 'doxy.realtime.components.file-transfer';

export { componentName, serviceName, moduleName };

export default angular
  .module(moduleName, [patientFileTransfer, doctorFileTransfer, filters])
  .factory(
    'FileTransferRealtimeComponent',
    function (
      RealtimeComponent,
      notificationFactory,
      $log,
      VideoProviderFactory
    ) {
      function showMessage(level, messageKey, messageParams) {
        notificationFactory.showCommon(
          level,
          messageKey,
          null,
          5000,
          messageParams
        );
      }

      return stampit({
        deepProps: {
          componentName,
          initPromise: null,
          state: {
            role: null,
          },
          basePath: '',
          name: 'File Transfer',
          events: {
            doctorSend: 'onDoctorSend',
            patientSend: 'onPatientSend',
            accepted: 'onAccepted',
            requestFile: 'onRequestFile',
            close: 'onClose',
            patientUploadError: 'onPatientUploadError',
          },
          innerMediatorEvents: {
            accept: 'accept',
            requestFile: 'requestFile',
            doctorUpload: 'doctorUpload',
            doctorUploadError: 'doctorUploadError',
            patientUploadError: 'patientUploadError',
            patientUpload: 'patientUpload',
            cancel: 'cancel',
          },
        },
        methods: {
          cancel() {
            // Sometimes there's a circumstance when this.target is undefined at this point
            // (perhaps some edge case on call end or alike)
            // Quick band-aid: just see who's on the call now and send them this "close" message
            // TODO: find the root cause why this is happening (not super urgent)

            this.target =
              this.target ||
              VideoProviderFactory.activeProvider.peopleCollection.models[0];
            if (this.target) this.sendToTarget('close');
            this.close();
          },

          open({ target, state, modalContentUrl }) {
            this.target = target;
            this.state = state;
            this.createInnerMediator();
            this.createScope(['state', 'innerMediator', 'target']);
            this.openModal({
              contentTemplate: modalContentUrl,
              template: modalTemplateUrl,
            });
          },

          accept() {
            this.state.notificationsStatus = 'SUCCESS';
            this.sendToTarget('accepted');
          },

          reset() {
            this.hideModal();
            if (this.innerMediator) this.innerMediator.removeAllListeners();
            if (this.$scope) this.$scope.$destroy();
            this.$scope = this.target = this.innerMediator = null;
          },

          close() {
            this.state = {};
            this.reset();
          },

          //// doctor ////

          doctorOpen({ target, state, requestFileData }) {
            $log.debug('File Transfer: doctor open');
            this.open({
              target: target,
              state: state,
              modalContentUrl: doctorModalContentUrl,
            });
            if (requestFileData) this.requestFile(requestFileData);
          },

          onPatientSend({ file }, person) {
            if (this.target && this.target !== person) return;
            const state = {
              role: 'receiver',
              file: file,
              notificationsStatus: 'PENDING',
            };
            this.doctorOpen({ target: person, state: state });
          },

          doctorUpload(file) {
            this.state.file = file;
            this.state.notificationsStatus = 'PENDING';
            this.sendToTarget('doctorSend', { file: file });
          },

          doctorUploadError(err) {
            this.state.notificationsStatus = '';
            if (
              err.data.error.status === 422 &&
              err.data.error.message === 'Invalid file type'
            ) {
              showMessage('info', 'file-transfer.file-not-supported');
            } else {
              showMessage('error', 'file-transfer.upload-error');
            }
          },

          onPatientUploadError(data, person) {
            if (
              data.data.error.status === 422 &&
              data.data.error.message === 'Invalid file type'
            ) {
              showMessage('info', 'file-transfer.file-not-supported');
            } else {
              showMessage(
                'error',
                'file-transfer.patient-upload-error{username}',
                {
                  username: person.state.username,
                }
              );
            }
          },

          //// patient ////

          patientOpen({ target, state }) {
            $log.debug('File Transfer: patient open');
            this.open({
              target: target,
              state: state,
              modalContentUrl: patientModalContentUrl,
            });
          },

          onDoctorSend({ file }, person) {
            if (this.target && this.target !== person) return;
            const state = {
              file: file,
              notificationsStatus: 'PENDING',
              role: 'receiver',
            };
            this.patientOpen({ target: person, state: state });
          },

          patientUploadError(err) {
            this.state.notificationsStatus = 'REQUESTING';
            if (
              err.data.error.status === 422 &&
              err.data.error.message === 'Invalid file type'
            ) {
              showMessage('info', 'file-transfer.file-not-supported');
            } else {
              showMessage('error', 'file-transfer.upload-error');
            }
            this.sendToTarget('patientUploadError', err);
          },

          patientUpload(file) {
            this.state.file = file;
            this.state.notificationsStatus = 'PENDING';
            this.sendToTarget('patientSend', { file: file });
          },

          onAccepted(data, person) {
            $log.debug('onAccepted');
            this.state.notificationsStatus = 'SUCCESS';
            showMessage('success', 'file-transfer.accepted{username}', {
              username: person.state.username,
            });
          },

          requestFile(data) {
            this.state.role = 'receiver';
            this.state.notificationsStatus = 'REQUESTING';
            this.sendToTarget('requestFile', data);
          },

          onRequestFile({ token }, person) {
            if (this.target && this.target !== person) return;
            const state = {
              role: 'sender',
              token: token,
              notificationsStatus: 'REQUESTING',
            };
            this.patientOpen({ target: person, state: state });
          },

          onClose(data, person) {
            if (this.target !== person) return;

            if (this.state.notificationsStatus === 'SUCCESS')
              showMessage('success', 'file-transfer.ended-success{username}', {
                username: person.state.username,
              });
            else
              showMessage('warning', 'file-transfer.ended{username}', {
                username: person.state.username,
              });

            this.close();
          },
        },
      }).compose(RealtimeComponent);
    }
  ).name;
